import Error from '../../../components/Error/Error';
import { DataType } from '../../../hooks/content/useFetchedTree';
import { ErrorBoundary } from '@sentry/react-native';
import { FC } from 'react';
import { TreeFetch } from '../../../components/Content/TreeFetch';
import { TreeNav } from '../../../components/Content/TreeNav/TreeNav';
import { observer } from 'mobx-react';
import { useGlobalSearchParams } from 'expo-router';
import { useStores } from '../../../hooks/useStores';


interface Params extends Record<string, string> {
  pathId: string;
  sessionId: string;
  source: DataType.SESSION;
  reckoningId: string;
  fromReckoning: 'true' | 'false';
  fromPath: 'true' | 'false';
}

/** every flow is a session: the branching screen plays the session given by id */
const Branching: FC = () => {
  const params = useGlobalSearchParams<Params>();
  const { language } = useStores();
  const id = params.sessionId;
  const source = DataType.SESSION;
  if (!id) {
    return <Error labels={{GENERIC: language?.translate?.MOBILE?.ERROR?.GENERIC}} />;
  }

  return (
    <ErrorBoundary
      key={id?.toString()}
      onError={(error, errorInfo) => {
        console.error('ErrorBoundary', error, errorInfo);
      }}
      fallback={
        <Error labels={{GENERIC: language?.translate?.MOBILE?.ERROR?.GENERIC}} />
      }
    >
      <TreeFetch
        dataId={id as string}
        dataType={source as DataType}
        pathId={params.pathId}
        reckoningId={params.reckoningId}
        fromPath={params.fromPath === 'true'}
        fromReckoning={!!params.reckoningId}
      >
        <TreeNav
          id={id as string}
          type={source}
          pathId={params.pathId}
          reckoningId={params.reckoningId}
          fromPath={params.fromPath === 'true'}
          fromReckoning={params.fromReckoning === 'true'}
        />
      </TreeFetch>
    </ErrorBoundary>
  );
};

export default observer(Branching);
